module.exports = __webpack_public_path__ + "img/tonghua4.1be5b33c.png";